import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
};

const phases = [
  {
    step: "Paso 1",
    title: "Diagnóstico de Capital de Marca",
    start: 1,
    duration: 2,
    color: "bg-[#60a5fa]",
  },
  {
    step: "Paso 2",
    title: "Percepción Objetivo",
    start: 3,
    duration: 2,
    color: "bg-[#3b82f6]",
  },
  {
    step: "Paso 3",
    title: "Arquitectura de Capital de Marca",
    start: 5,
    duration: 2,
    color: "bg-[#2563eb]",
  },
  {
    step: "Paso 4",
    title: "Dirección Estratégica",
    start: 7,
    duration: 2,
    color: "bg-[#1d4ed8]",
  },
  {
    step: "Paso 5",
    title: "Activación y Gobernanza",
    start: 8,
    duration: 2,
    color: "bg-[#1e40af]",
  },
];

const milestones = [
  { week: 2, label: "Diagnóstico listo" },
  { week: 4, label: "Percepción Objetivo definida" },
  { week: 6, label: "Arquitectura validada" },
  { week: 8, label: "Dirección aprobada" },
  { week: 9, label: "Sistema de gobernanza activo" },
];

const totalWeeks = 9;

export const GanttChart = () => {
  return (
    <section className="py-14 md:py-24 bg-[#0a1628]">
      <div className="container px-4 max-w-5xl mx-auto">
        <motion.div {...fadeUp} transition={{ duration: 0.6 }} className="mb-10">
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#60a5fa] font-semibold mb-4">
            Línea de tiempo
          </p>
          <h2 className="font-display text-2xl md:text-4xl font-bold text-white leading-tight">
            60 días en movimiento.
          </h2>
          <p className="text-white/60 text-sm md:text-base mt-3 max-w-2xl">
            Cada paso tiene un orden, una duración y una entrega. La progresión está diseñada para
            generar claridad primero, dirección después, y gobernanza al final.
          </p>
        </motion.div>

        <motion.div
          {...fadeUp}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 md:p-8 overflow-x-auto"
        >
          <div className="min-w-[720px]">
            {/* Header: weeks */}
            <div className="grid grid-cols-[200px_1fr] gap-4 mb-4">
              <div className="text-white/40 text-xs uppercase tracking-wider font-semibold">
                Etapa
              </div>
              <div className="grid" style={{ gridTemplateColumns: `repeat(${totalWeeks}, minmax(0, 1fr))` }}>
                {Array.from({ length: totalWeeks }).map((_, i) => (
                  <div
                    key={i}
                    className="text-center text-white/40 text-[11px] uppercase tracking-wider border-l border-white/10 first:border-l-0"
                  >
                    S{i + 1}
                  </div>
                ))}
              </div>
            </div>

            {/* Bars */}
            <div className="space-y-3">
              {phases.map((phase, i) => (
                <motion.div
                  key={phase.step}
                  initial={{ opacity: 0, x: -10 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.08 }}
                  className="grid grid-cols-[200px_1fr] gap-4 items-center"
                >
                  <div className="pr-3">
                    <p className="text-[#60a5fa] text-[10px] tracking-[0.18em] font-semibold uppercase">
                      {phase.step}
                    </p>
                    <p className="text-white text-sm font-medium leading-tight">{phase.title}</p>
                  </div>
                  <div
                    className="grid relative h-8"
                    style={{ gridTemplateColumns: `repeat(${totalWeeks}, minmax(0, 1fr))` }}
                  >
                    <div
                      className={`h-6 rounded-md ${phase.color} shadow-lg shadow-blue-900/20 self-center`}
                      style={{
                        gridColumnStart: phase.start,
                        gridColumnEnd: phase.start + phase.duration,
                      }}
                    />
                  </div>
                </motion.div>
              ))}
            </div>

            {/* Milestones */}
            <div className="mt-8 pt-6 border-t border-white/10">
              <p className="text-white/40 text-xs uppercase tracking-wider font-semibold mb-4">
                Hitos clave
              </p>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                {milestones.map((m, i) => (
                  <motion.div
                    key={m.label}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.3, delay: 0.4 + i * 0.06 }}
                    className="rounded-xl border border-white/10 bg-white/[0.04] p-3"
                  >
                    <p className="text-[#60a5fa] text-[10px] tracking-[0.18em] font-semibold uppercase mb-1">
                      Semana {m.week}
                    </p>
                    <p className="text-white/80 text-sm leading-snug">{m.label}</p>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
